/**
 * Appearance: the sending UI is light only. Dark mode was removed, so this pins
 * `data-theme="light"` on <html> and clears any saved preference from when a
 * dark option existed.
 */
export const THEME_KEY = "np_theme";

/** Apply light mode. Called once before first render. */
export const applyThemePreference = () => {
  document.documentElement.dataset.theme = "light";
  try {
    window.localStorage.removeItem(THEME_KEY);
  } catch (e) {
    // storage unavailable — nothing to clear
  }
};
